import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteGiroMercado,
  getGirosMercados,
  patchGiroMercado,
  postGiroMercado,
} from 'api/empresas/giroDeMercado';

// eslint-disable-next-line react/prop-types
const GiroDeMercado = ({ permission }) => (
  <PlainCRUD
    title="Giro de mercado"
    permission={permission}
    get={getGirosMercados}
    post={postGiroMercado}
    patch={patchGiroMercado}
    delete={deleteGiroMercado}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default GiroDeMercado;
